<template>
  <Teleport to="body">
    <transition name="toastSlide">
      <div v-if="toast.shouldShowToast" class="toast" data-testid="toast">
        <CheckedText v-if="toast.type === 'SUCCESS'" :text="toast.message" />
        <WarningText v-if="toast.type === 'WARNING'" :multiline="toast.multiline">{{ toast.message }}</WarningText>
        <ErrorText v-if="toast.type === 'ERROR'" :text="toast.message" />
      </div>
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
import CheckedText from '@/components/atoms/text/CheckedText/CheckedText.vue';
import ErrorText from '@/components/atoms/text/ErrorText/ErrorText.vue';
import WarningText from '@/components/atoms/text/WarningText/WarningText.vue';
import { useToast } from '@/composables/ui/useToast';
const { toast } = useToast();
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  top: 24px;
  left: calc(50%);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 94px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  z-index: 300; // modal z-index is 200
}

.toastSlide {
  $move: 100px;

  &-enter-active {
    transition: all 0.2s;
    transform: translateY(-$move);
  }

  &-leave-active {
    transition: all 0.2s;
  }

  &-enter-to {
    transform: translateY(0);
  }

  &-leave-to {
    opacity: 0;
  }
}
</style>
